import React from "react";
import T from "prop-types";
import _ from "lodash";
import { Warning } from "MODULES/shared/components/Warning";
import { dollars } from "LIB/formatters/currency";

export function CapAmountWarning({ lineItem, originalEval }) {
  if (
    _.get(lineItem, "cap_amount") &&
    originalEval > parseFloat(lineItem.cap_amount)
  ) {
    return (
      <Warning>
        {`Estimate has come above Repair/Overhaul Cap amount of ${dollars(
          lineItem.cap_amount
        )}. Part should be
            considered for Partial Credit or RMA Request`}
      </Warning>
    );
  }

  return null;
}

CapAmountWarning.propTypes = {
  lineItem: T.shape({
    cap_amount: T.number
  }),
  originalEval: T.number.required
};



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Detail/LineItems/Warnings.jsx